import { render } from "./Pointsrecord.vue?vue&type=template&id=62eeaa77&scoped=true"
import script from "./Pointsrecord.vue?vue&type=script&lang=js"
export * from "./Pointsrecord.vue?vue&type=script&lang=js"

import "./Pointsrecord.vue?vue&type=style&index=0&id=62eeaa77&lang=css"
import "./Pointsrecord.vue?vue&type=style&index=1&id=62eeaa77&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62eeaa77"]])

export default __exports__